module.exports = {
  lang: {
    t1: "Главная",
    t2: "Визитная карточка",
    t3: "Подписаться",
    t4: "Контакты",
    t5: "Сообщения",
    t6: "Войти",
    t7: "Регистрация",
    t8: "Глобальная новая платформа для деловых связей, новый рубеж цифрового маркетинга предприятий",
    t9: "WeMeet - Вход по номер телефона",
    t10: "Номер телефона",
    t11: "Код подтверждения",
    t12: "Пожалуйста, введите номер телефона",
    t13: "Пожалуйста, введите код подтверждения",
    t14: "Получить",
    t15: "Вход",
    t16: "Пожалуйста, введите номер телефона в правильном формате",
    t17: "Код подтверждения отправлен",
    t18: "Введен неверный код подтверждения. Пожалуйста, проверьте и введите заново.",
    t19: "Успешный вход",
    t20: "Ваш код подтверждения — (0). Используйте его в течение {1} минуты(й).",
    t21: "Отменить",
    t22: "Подтвердить",
    t23: "Полезные советы",
    t24: "Регистрация вашего аккаунта WeMeet еще не завершена. Принимайте меры уже сейчас, чтобы закончить процесс регистрации и наслаждаться разнообразными взаимодействиями и бесконечными возможностями.",
    t25: "Перейти к регистрации",
    t26: "Вход в WeMeet по электронной почте",
    t27: "Имя учетной записи",
    t28: "Введите вашу электронную почту",
    t29: "Пароль",
    t30: "Введите ваш пароль",
    t31: "Забыли пароль?",
    t32: "Войти",
    t33: "Другие способы входа",
    t34: "Уже зарегистрировались в мини-приложении WeMeet? Используйте его.",
    t35: "Войти с номером телефона",
    t36: "Сначала введите адрес электронной почты.",
    t37: "Сначала введите пароль.",
    t38: "Формат адреса электронной почты неверный",
    t39: "Если у вас уже есть учетная запись WeMeet, вы можете войти напрямую",
    t40: "Войти",
    t41: "Фотография профиля",
    t42: "Пожалуйста, загрузите реальное фото профиля",
    t43: "Полное имя",
    t44: "Имя",
    t45: "Фамилия",
    t46: "Название организации",
    t47: "Пожалуйста, укажите название вашей организации",
    t48: "Должность",
    t49: "Пожалуйста, укажите название своей должности в организации",
    t50: "Электронная почта",
    t51: "Введите вашу электронную почту",
    t52: "Номер телефона",
    t53: "Пожалуйста, введите номер телефона",
    t54: "Регион",
    t55: "Пожалуйста, выберите регион",
    t56: "Зона",
    t57: "Пожалуйста, выберите область, город и район",
    t58: "Адрес",
    t59: "Пожалуйста, укажите свой адрес",
    t60: "Я прочитал(а) и согласен(на) с",
    t61: "Условия предоставления услуг",
    t62: "Политика конфиденциальности",
    t63: "Продолжить",
    t64: "Пожалуйста, сначала отметьте пользовательское соглашение",
    t65: "Пожалуйста, укажите ваше имя",
    t66: "Пожалуйста, заполните вашу фамилию",
    t67: "Сначала заполните свой адрес электронной почты",
    t68: "Сначала заполните название вашей организации",
    t69: "Формат адреса электронной почты неверный",
    t70: "Отменить",
    t71: "Завершить",
    t72: "Проверить номер мобильного телефона",
    t73: "Номер телефона",
    t74: "Код подтверждения",
    t75: "Пожалуйста, введите код подтверждения",
    t76: "Получить",
    t77: "Пропустить проверку",
    t78: "Отправить",
    t79: "Подтверждено",
    t80: "Введен неверный код подтверждения. Пожалуйста, проверьте и введите заново.",
    t81: "Пропущено",
    t82: "Полезные советы",
    t83: "Введенный вами номер телефона уже зарегистрирован в системе WeMeet. Не нужно регистрироваться повторно, пожалуйста, авторизуйтесь сейчас.",
    t84: "Перейти к авторизации",
    t85: "Полезные советы",
    t86: "Введенная вами электронная почта уже зарегистрирована в системе WeMeet. Не нужно регистрироваться повторно, пожалуйста, авторизуйтесь сейчас.",
    t87: "Перейти к авторизации",
    t88: "Ссылка для подтверждения отправлена.",
    t89: "Пожалуйста, проверьте свой электронный ящик и нажмите на ссылку, чтобы завершить регистрацию.",
    t90: "Понятно",
    t91: "Добро пожаловать в WeMeet",
    t92: "Добро пожаловать в WeMeet! Чтобы завершить регистрацию, нажмите на кнопку. Дружеский напоминание: этот ссылка действительна в течение 24 часов, пожалуйста, оперативно предпринимайте действия.",
    t93: "Регистрация завершена",
    t94: "Ваш электронный адрес был активирован. Пожалуйста, введите пароль.",
    t95: "Введите пароль",
    t96: "Введите ваш пароль",
    t97: "Подтвердите пароль",
    t98: "Пожалуйста, введите пароль еще раз",
    t99: "Должен содержать комбинацию прописных и строчных букв, цифр и специальных символов, длина от 8 до 20 символов",
    t100: "Введите ваш пароль",
    t101: "Пожалуйста, введите пароль еще раз",
    t102: "Пароли не совпадают",
    t103: "Поздравляем с успешной регистрацией",
    t104: "Вы успешно вошли в WeMeet. Теперь вы можете продолжить свои предыдущие действия.",
    t105: "Продолжайте свой опыт",
    t106: "Полезные советы",
    t107: "Ссылка устарела. Пожалуйста, нажмите на кнопку, чтобы получить ее повторно.",
    t108: "Переслать",
    t109: "Условия обслуживания",
    t110: "Политика конфиденциальности",
    t111: "Восстановить пароль",
    t112: "Пожалуйста, укажите аккаунт, для которого вы хотите восстановить пароль",
    t113: "Имя учетной записи",
    t114: "Введите вашу электронную почту",
    t115: "Отправить",
    t116: "Сначала введите адрес электронной почты.",
    t117: "Формат адреса электронной почты неверный",
    t118: "E-mail отправлено",
    t119: "Пожалуйста, проверьте свою электронную почту, перейдите по ссылке и сбросьте пароль.",
    t120: "Понятно",
    t121: "Сброс пароля — WeMeet",
    t122: "Ваш запрос на сброс пароля подтверждён, система создала временный ссылка для сброса пароля. Дружеский напоминание: этот ссылка действительна в течение 24 часов, пожалуйста, оперативно предпринимайте действия.",
    t123: "Сброс пароля",
    t124: "Успешно сброшен пароль",
    t125: "Вы вошли в систему WeMeet. Добро пожаловать обратно.",
    t126: "Перейти на главную страницу",
    t127: "Контакты",
    t128: "Новая заявка на добавление в контакты",
    t129: "Согласиться",
    t130: "Игнорировать",
    t131: "Утвержденный",
    t132: "Игнорировано",
    t133: "Следующий",
    t134: "Подписан(-а)",
    t135: "Сообщения",
    t136: "Необработанный запрос",
    t137: "Введите имя или номер телефона",
    t138: "Ничего не найдено",
    t139: "Больше нет",
    t140: "Запрос на контакт",
    t141: "Согласиться",
    t142: "Игнорировать",
    t143: "Утвержденный",
    t144: "Игнорировано",
    t145: "Пространство WeMeet AI",
    t146: "Подписан(-а)",
    t147: "Отписался(-ась)",
    t148: "vCard",
    t149: "Подключить",
    t150: "Отправить сообщение",
    t151: "Ожидает одобрения",
    t152: "Удалить контакт",
    t153: "Личное представление",
    t154: "Личная информация",
    t155: "Полезные советы",
    t156: "Ваш запрос на контакт отправлен. После одобрения вы будете автоматически следить за ним. Также вы можете выбрать подписку на него сейчас, чтобы узнать больше о нем.",
    t157: "Не следить сейчас",
    t158: "Подписаться",
    t159: "Подписан(-а)",
    t160: "Удалить связь с контактами",
    t161: "После удаления связи с контактами другой пользователь больше не сможет просматривать ваши личные данные, но он не отменит одновременно подписку на вас.",
    t162: "Передумайте",
    t163: "Удалить контакт",
    t164: "Операция выполнена успешно",
    t165: "Ассистент AI WeMeet",
    t166: "Введите свой вопрос",
    t167: "Отправить",
    t168: "Обратите внимание, что содержание взаимодействия с ИИ может быть неточным и не отражает точку зрения платформы.",
    t169: "Визитная карточка WeMeet",
    t170: "Скачать",
    t171: "Редактировать визитную карточку",
    t172: "Скачать QR-код",
    t173: "Изображение сгенерировано. Сохраните его. Для сохранения контакта отсканируйте QR-код.",
    t174: "Фотография профиля",
    t175: "Пожалуйста, загрузите реальное фото профиля",
    t176: "Полное имя",
    t177: "Имя",
    t178: "Фамилия",
    t179: "Введите имя",
    t180: "Название организации",
    t181: "Пожалуйста, укажите название вашей организации",
    t182: "Должность",
    t183: "Пожалуйста, укажите название своей должности в организации",
    t184: "Электронная почта",
    t185: "Введите вашу электронную почту",
    t186: "Номер телефона",
    t187: "Пожалуйста, введите номер телефона",
    t188: "Регион",
    t189: "Пожалуйста, выберите регион",
    t190: "Зона",
    t191: "Пожалуйста, выберите область, город и район",
    t192: "Адрес",
    t193: "Пожалуйста, укажите свой адрес",
    t194: "Пожалуйста, укажите ваше имя",
    t195: "Пожалуйста, заполните вашу фамилию",
    t196: "Сначала заполните свой адрес электронной почты",
    t197: "Сначала заполните название вашей организации",
    t198: "Формат адреса электронной почты неверный",
    t199: "Чат-комната",
    t200: "Галерея фотографий",
    t201: "Сделать фото",
    t202: "Введите сообщение",
    t203: "Отправить",
    t204: "Прочитано",
    t205: "Непрочитано",
    t206: "Просрочен срок отзыва",
    t207: "Отменить",
    t208: "Фото",
    t209: "Альбом",
    t210: "Снимать",
    t211: "Выбрать из альбома",
    t212: "Отменить",
    t213: "Фото",
    t214: "Портрет",
    t215: "Предпросмотр",
    t216: "Завершить",
    t217: "Пространство WeMeet AI",
    t218: "Свяжитесь с нами",
    t219: "Свяжитесь со мной",
    t220: "Полное имя",
    t221: "Организация",
    t222: "Должность",
    t223: "Телефон",
    t224: "Электронная почта",
    t225: "Регион",
    t226: "Зона",
    t227: "Адрес",
    t228: "Пожалуйста, укажите ваше имя",
    t229: "Пожалуйста, укажите название вашей организации",
    t230: "Пожалуйста, укажите ваше место работы",
    t231: "Пожалуйста, введите ваш номер телефона",
    t232: "Пожалуйста, укажите ваш адрес электронной почты",
    t233: "Пожалуйста, выберите регион",
    t234: "Пожалуйста, выберите область, город и район",
    t235: "Пожалуйста, введите адрес",
    t236: "Намерение",
    t237: "Покупка продукции",
    t238: "Продукция агента",
    t239: "Сотрудничество на рынке",
    t240: "Другое",
    t241: "Пожалуйста, укажите ваше имя",
    t242: "Пожалуйста, укажите название вашей организации",
    t243: "Пожалуйста, укажите ваш адрес электронной почты",
    t244: "Формат адреса электронной почты неверный",
    t245: "Сообщение отправлено",
    t246: "Оставить сообщение",
    t247: "Введите содержание вашего запроса",
    t248: "Подтвердить",
    t249: "Пожалуйста, войдите или зарегистрируйтесь сначала",
    t250: "Подписчики",
    t251: "Свяжитесь с нами",
    t252: "Продукты",
    t253: "Команда",
    t254: "Обзор",
    t255: "Альбом",
    t256: "Квалификация",
    t257: "Уставной капитал",
    t258: "Дата основания",
    t259: "Регистрационный адрес",
    t260: "Верховье",
    t261: "Среднее течение",
    t262: "Нижнее течение",
    t263: "Industrias asociadas",
    t264: "Процесс",
    t265: "Сохранить",
    t266: "Проверено",
    t267: "Китайский",
    t268: "Английский",
    t269: "Французский",
    t270: "Русский",
    t271: "Испанский",
    t272: "Японский",
    t273: "Корейский",
    t274: "Индонезийский",
    t275: "Вьетнамский",
    t276: "Немецкий",
    t277: "Турецкий",
    t278: "Итальянский",
    t279: "Португальский",
    t280: "Тайский",
    t281: "Малайский",
    t282: "Арабский",
    t283: "Неправильное имя пользователя или пароль",
    t284: "Пожалуйста, прочитайте и подтвердите свое согласие с пользовательским соглашением WeMeet перед продолжением",
    t285: "Нет соответствующего контента",
    t286: "Тип",
    t287: "Атрибут",
    t288: "Подробности",
    t289: "Другое",
    t290: "Всего 2 продукта",
    t291: "{1} приглашает вас посетить WeMeet AI Space {2}",
    t292: "Нажмите здесь, чтобы увидеть пример или введите вопрос:",
    t293: "Обновить",
    t294: "Вы также можете нажать на визитную карточку ниже, чтобы добавить контакты для получения дополнительной информации:",
    t295: "Узнать",
    t296: "Цифровые встречи WeMeet",
    t297: "Цифровые выставки WeMeet",
    t298: "Carte de visite et Espace WeMeet AI",
    t299: "Как стать участником организации WeMeet",
    t300: "WeMeet Цифровая конференция предоставляет вам всеобъемлющее онлайн-решение для проведения встреч, включая, но не ограничиваясь, создание и публикацию встреч, управление регистрацией участников, электронную регистрацию, планирование встреч, обмен материалами встречи, обсуждения в реальном времени и взаимодействие с гостями.",
    t301: 'WeMeet Цифровая выставка, помогающая быстро создать микро-официальный веб-сайт выставки. Показывать информацию об экспонентах, описания экспонатов, прямые трансляции выставки, регистрацию на выставку, программу мероприятий и многое другое, чтобы участвующие компании и аудитория могли легко понять детали выставки. Для использования функции WeMeet Цифровая выставка, пожалуйста, сначала завершите процесс вступления в учреждение. Нажмите на "Мой", прокрутите вниз до "Сервисный центр" - "Вступление в учреждение" и следуйте инструкциям, чтобы завершить процесс вступления.',
    t302: "Пользователям WeMeet достаточно авторизовать свой идентификатор WeChat, номер телефона и завершить регистрацию на платформе, чтобы получить личную цифровую визитную карточку и поддерживать свою личную AI-гостиную (включая личное резюме, обновления, фотографии, документы и т. д.).",
    t303: 'Щелкните на вариант "Мой" на нижней панели меню мини-программы, чтобы обновить страницу личной визитной карточки и улучшить личную домашнюю страницу.',
    t304: "Комбинация заглавных и строчных букв, цифр, знаков препинания, длиной от 8 до 20 символов.",
    t305: "Введите название продукта",
    t306: "Нет больше",
    t307: "Нажмите в правом верхнем углу",
    t308: "Выберите предпочитаемый способ обмена",
    t309: "Я понял",
    t310: "Пожалуйста, сначала завершите регистрацию и вход",
    t311: "Узнать больше",
    t312: "Связанные продукты",
    t313: "Спасибо за посещение",
    t314: "Выйти",
    t315: "Подписанные организации",
    t316: "Предыдущий",
    t317: "Следующий",
    t318: "Нет",
    t319: "{1} приглашает вас посетить {2}",
    t320: "Лаунж AI не поддерживает текущий язык",
    t321: "Лаунж AI переключился на текущий язык",
    t322: "Ссылка активирована",
    t323: "Сеть занята, пожалуйста, попробуйте позже",
    t324: "Детали продукта переключены на текущий язык",
    t325: "Детали продукта в настоящее время не поддерживаются на данном языке",
    t326: "Здравствуйте, я интеллектуальный помощник WeMeet, готовый предоставить вам внимательное обслуживание в любое время! Чем я могу вам помочь?",
    t327: "Введите название",
    t328: "Я нашел соответствующую контактную информацию, пожалуйста, проверьте контактную карточку ниже.",
    t329: "Вложение",
    t330: "Я не нашел соответствующей контактной информации.",
    t331: "Я переслал ваш запрос ответственному коллеге ниже; вы также можете нажать на визитную карточку, чтобы немедленно связаться.",
    t332: "Выставка",
    t333: "Пожалуйста",
    t334: "Пользователь",
    t335: "Нет больше",
    t336: "Обновление успешно",
    t337: "Загрузка",
    t338: "Освободите для обновления",
  },
};

// 俄罗斯
